import { IsOptional, IsString } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateEstablishmentRoleDto {
  @ApiPropertyOptional({ type: 'string', description: "Code du rôle d'établissement" })
  @IsOptional()
  @IsString()
  code?: string

  @ApiPropertyOptional({ type: 'string', description: "Nom du rôle d'établissement" })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({ type: 'string', description: 'Permissions (JSON)' })
  @IsOptional()
  @IsString()
  permissions?: string
}
